export function loading() {
  const loadingEl = document.querySelector('.p-loading'); // SCSSのクラス名
  const kvEl = document.querySelector('.js-kv');

  if (!loadingEl) return;

  const hasVisited = sessionStorage.getItem('hasVisited');

  if (!hasVisited) {
    // 【初回アクセス】
    // 1. 1フレーム待ってからクラスを付与する（確実なtransition発火のため）
    setTimeout(() => {
      
      // クラスを付与してフェードアウトなどの演出を開始
      loadingEl.classList.add('is-active');

      // 2. transition終了を検知
      loadingEl.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'opacity') {
          if (kvEl) {
            kvEl.classList.add('is-animated');
          }
          loadingEl.style.display = 'none';
        }
      }, { once: true });

      // 3. バックアップ用のタイマー（1.5秒は演出時間に合わせて調整してください）
      setTimeout(() => {
        if (kvEl && !kvEl.classList.contains('is-animated')) {
          kvEl.classList.add('is-animated');
          loadingEl.style.display = 'none';
        }
      }, 1500);

      sessionStorage.setItem('hasVisited', 'true');

    }, 2000); // ← ここで「2秒（2000ms）」を指定

  } else {
    // 【2回目以降】
    loadingEl.style.display = 'none';
    if (kvEl) {
      kvEl.classList.add('is-animated');
    }
  }
}